var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.57803 0 0 3.57834 0 8C0 12.422 3.57834 16 8 16C12.422 16 16 12.4217 16 8C16 3.57803 12.4216 0 8 0ZM8 14.75C4.26897 14.75 1.25 11.7308 1.25 8C1.25 4.26897 4.26922 1.25 8 1.25C11.731 1.25 14.75 4.26922 14.75 8C14.75 11.731 11.7308 14.75 8 14.75Z",
    fill: "#6B5F5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.69775C7.65481 6.69775 7.375 6.97757 7.375 7.32275V11.3475C7.375 11.6927 7.65481 11.9725 8 11.9725C8.34519 11.9725 8.625 11.6927 8.625 11.3475V7.32275C8.625 6.97757 8.34519 6.69775 8 6.69775Z",
    fill: "#6B5F5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.93262C8.46599 5.93262 8.84375 5.55486 8.84375 5.08887C8.84375 4.62288 8.46599 4.24512 8 4.24512C7.53401 4.24512 7.15625 4.62288 7.15625 5.08887C7.15625 5.55486 7.53401 5.93262 8 5.93262Z",
    fill: "#6B5F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/iIcon.08bf4fc9363b8783317899a200214956.svg";
export { ForwardRef as ReactComponent };